import { render } from "./page-bar.vue?vue&type=template&id=66935fb2&scoped=true"
import script from "./page-bar.vue?vue&type=script&lang=js"
export * from "./page-bar.vue?vue&type=script&lang=js"

import "./page-bar.vue?vue&type=style&index=0&id=66935fb2&lang=scss&scoped=true"

import exportComponent from "D:\\Afwct\\emis2.0\\emis-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66935fb2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QPageSticky,QTabs,QTab,QIcon,QTooltip,QToolbar});
